export const getSx = () => {
  return {
    sidebarContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      background: "linear-gradient(180deg, #667eea 0%, #764ba2 100%)",
      height: "100vh",
      position: 'fixed',
      top: 0,
      left: 0,
      padding: { xs: "10px 0", md: "10px 0 30px" },
      zIndex: 9,
      boxSizing: "border-box",
      boxShadow: "4px 0 30px rgba(102, 126, 234, 0.3)",
    },
    sidebarItems: {
      display: "flex",
      gap: "1rem",
      alignItems: "center",
      position: "relative",
      padding: "0 20px",
    },
    smallLogo: {
      aspectRatio: "1.46",
      objectFit: "contain",
      objectPosition: "center",
      width: "48px",
      height: "56px",
      overflow: "hidden",
      maxWidth: "100%",
    },
    profileName: {
      fontSize: {
        xs: "15px",
        md: "15px",
        lg: "16px",
        xl: "18px"
      },
      fontWeight: "600",
      lineHeight: 1.2,
      textTransform: "capitalize",
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      color: '#ffffff',
    },
    email: {
      fontSize: {
        xs: "12px",
        md: "12px",
        lg: "13px",
        xl: "14px"
      },
      fontWeight: "500",
      opacity: 0.85,
      lineHeight: 1.1,
      display: 'block',
      marginTop: '3px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      color: 'rgba(255, 255, 255, 0.9)',
    },
    arrowLeftCircle: {
      cursor: "pointer",
      position: "absolute",
      bottom: "-85px",
      right: "-42px",
    },
    itemList: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    sidebarItemContainer: {
      display: "flex",
      position: "relative",
      alignItems: "center",
      justifyContent: {
        xs: 'center',
        sm: 'flex-start',
        md: 'flex-start',
        lg: 'flex-start',
        xl: 'flex-start',
      },
      cursor: "pointer",
      borderRadius: "16px",
      fontWeight: 500,
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      border: "1px solid rgba(255, 255, 255, 0.1)",
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.15)",
        transform: "translateX(4px)",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
      },
    },
    sidebarItem: {
      width: "24px",
      height: "24px",
      borderRadius: "50%",
      position: "relative",
      marginRight: "15px",
    },
    imageContainer: {
      width: {
        xs: "20px",
        sm: "22px",
        md: "24px",
        lg: "26px",
        xl: "28px"
      },
      height: {
        xs: "20px",
        sm: "22px",
        md: "24px",
        lg: "26px",
        xl: "28px"
      },
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexShrink: 0,
    },
    sidebarLabel: {
      fontSize: {
        xs: "12px",
        sm: "12px",
        md: "13px",
        lg: "14px",
        xl: "16px"
      },
      fontWeight: 500,
      paddingLeft: {
        xs: "8px",
        sm: "10px",
        md: "12px",
        lg: "15px",
        xl: "18px"
      },
      width: '100%',
      flex: 1,
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      color: '#ffffff',
    },
    logoutContainer: {
      display: "flex",
      position: "fixed",
      bottom: "2%",
      alignItems: "center",
      cursor: "pointer",
      padding: "18px",
      fontWeight: 500,
      margin: { xs: "5px 10px", md: "8px 15px" },
    },
    logoutIcon: {
      backgroundColor: "rgba(255, 255, 255, 0.2)",
      width: "24px",
      height: "24px",
      borderRadius: "50%",
      position: "relative",
      marginRight: "10px",
    },
    profileContainer: {
      display: "flex",
      alignItems: "center",
      borderTop: "1px solid rgba(255, 255, 255, 0.15)",
      marginTop: "auto",
      position: 'absolute',
      bottom: 0,
      left: 0,
      background: 'rgba(0, 0, 0, 0.15)',
      backdropFilter: 'blur(10px)',
      width: '100%',
      boxSizing: 'border-box',
    },
    profileDetails: {
      marginLeft: {
        xs: 0,
        sm: 0,
        md: 0,
        lg: 0,
        xl: 0
      },
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      flex: 1,
      minWidth: 0,
    },
    logoutText: {
      color: "#ffffff",
      fontSize: "16px",
      fontWeight: 500,
      my: "auto",
      paddingLeft: "15px",
      display: { xs: "none", md: "block" },
    },
  };
};
